import DOMPurify from 'dompurify';
import { CardItemType } from '../types/types';

const CardItem = ({ posttype, post, newTab, keyFacts }: CardItemType) => {
	if (posttype && posttype === 'cases_post_type') {
		if (keyFacts) {
			return (
				<div className="card">
					<div className="card__inner">
						{post?.image && <div className="card__header" dangerouslySetInnerHTML={{ __html: post?.image }}></div>}
						<div className="card__content">
							<h3 className="card__title" dangerouslySetInnerHTML={{ __html: post?.title }}></h3>
							<div className="card__key-facts" dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(post?.keyfacts) }}></div>
						</div>
					</div>
				</div>
			);
		} else {
			return (
				<div className="card">
					<a className="card__inner" href={post?.link} target={`${newTab ? '_blank' : '_self'}`}>
						{post?.image && <div className="card__header" dangerouslySetInnerHTML={{ __html: post?.image }}></div>}
						<div className="card__content">
							<h3 className="card__title" dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(post?.title) }}></h3>
						</div>
					</a>
				</div>
			);
		}
	} else {
		return (
			<div className="card">
				<a className="card__inner" href={post?.link} target={`${newTab ? '_blank' : '_self'}`}>
					{post?.image && <div className="card__header" dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(post?.image) }}></div>}
					<div className="card__content">
						<h3 className="card__title" dangerouslySetInnerHTML={{ __html: post?.title }}></h3>
						{post?.excerpt && <p className="card__text" dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(post?.excerpt) }}></p>}
						<span className="card__cta btn btn--link">{post?.link_text}</span>
					</div>
				</a>
			</div>
		);
	}
};
export default CardItem;
